var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBasket = function SvgBasket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.5,
    d: "M0 6.75h22M4 16.75h14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.5547 -.83205 .8406 .54167 4 7)",
    stroke: "currentColor",
    strokeWidth: 0.5,
    d: "M0-.25h7.211"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.55467 .83207 -.84062 .54163 14 1)",
    stroke: "currentColor",
    strokeWidth: 0.5,
    d: "M0-.25h7.211"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.5,
    d: "m2.245 6.951 2 10M17.755 16.951l2-10"
  })));
};
export default SvgBasket;